import ms250 from "./ms250";
import cretaecroprate from "./cretaecroprate";
import ms74 from "./ms74";
import ms79 from "./ms79";

export default {
    ms250,
    cretaecroprate,
    ms74,
    ms79
}